module.exports = __webpack_public_path__ + "img/APP ICON.e8e78b00.png";